/** Wait until iteratee returns true to resolve the promise */
export const waitFor = (iteratee, interval = 50) =>
  new Promise((resolve) => {
    let i = setInterval(() => {
      if (iteratee()) {
        clearInterval(i);
        resolve();
      }
    }, interval);
  });
